import { getIsSearchPage, isCatalogPage, isForYouPage, isItemPage, isPriceResultsPage } from '@/utils/urls';
import { Location } from 'react-router-dom';
import { useCallback } from 'react';
import { useTrackItemSaved } from '@/hooks/kameleoon/tracking/useTrackItemSaved';
import { useTrackItemSavedCatalogPage } from '@/hooks/kameleoon/tracking/useTrackItemSavedCatalogPage';
import { useTrackItemSavedItemPage } from '@/hooks/kameleoon/tracking/useTrackItemSavedItemPage';
import { useTrackSavedPriceResultsItem } from '@/hooks/kameleoon/tracking/useTrackPriceResultsPage';
import { useTrackSavedSearchItem } from '@/hooks/kameleoon/tracking/useTrackSavedSearchItem';

interface UseTrackItemSaveProps {
    isItemDetailChild?: boolean;
    location: Location;
}

export const useTrackItemSave = ({ location }: UseTrackItemSaveProps) => {
    const trackItemSaved = useTrackItemSaved();
    const trackItemSavedCatalogPage = useTrackItemSavedCatalogPage();
    const trackItemSavedItemPage = useTrackItemSavedItemPage();
    const trackSavedPriceResultsItem = useTrackSavedPriceResultsItem();
    const trackSavedSearchItem = useTrackSavedSearchItem();

    return useCallback(() => {
        const isOnItemPage = isItemPage(location.pathname);
        const isOnSearchPage = getIsSearchPage(location.pathname);
        const isOnForYouPage = isForYouPage(location.pathname);
        const isOnCatalogPage = isCatalogPage(location.pathname);
        const isOnPriceResultsPage = isPriceResultsPage(location.pathname);
        const shouldTrackSavedSearchItem = isOnSearchPage || isOnForYouPage;

        trackItemSaved();

        if (isOnItemPage) {
            trackItemSavedItemPage();
        }

        if (isOnCatalogPage) {
            trackItemSavedCatalogPage();
        }

        if (isOnPriceResultsPage) {
            trackSavedPriceResultsItem();
        }

        if (shouldTrackSavedSearchItem) {
            trackSavedSearchItem();
        }
    }, [
        location.pathname,
        trackItemSaved,
        trackItemSavedItemPage,
        trackItemSavedCatalogPage,
        trackSavedPriceResultsItem,
        trackSavedSearchItem,
    ]);
};
